import { createFileRoute, redirect } from "@tanstack/react-router";
import { toast } from "react-toastify";
import CheckEmail from "@/components/singin/CheckEmail";
import { getFunctions, httpsCallable } from "firebase/functions"
import { useState } from "react";
import { ClipLoader } from "react-spinners";

const functions = getFunctions()
const sendEmail = httpsCallable(functions, 'sendEmail')

export const Route = createFileRoute("/_layout/forget-password")({
  beforeLoad: ({context}) => {
    if(context.auth.isAuthenticated){
      throw redirect({to: "/competitions"})
    }
  },
  component: ForgetPassword,
});

function ForgetPassword() {
  const [status, setStatus] = useState("")
  const [waiting, setWaiting] = useState(false)
  const updateEmail = async (email: string): Promise<string | undefined> => {
    try{
      setWaiting(true);
      await sendEmail(
        {
          data: {
            email: email,
            type: 'resetpassword',
          }
        }
      )
      setWaiting(false);
    }catch(error){
      toast.error("メール送信でエラーが発生しました。", {
        position: "bottom-left",
      });
      setWaiting(false);
      return
    }
    setStatus("success")
    toast.success("再設定用のメールを送信しました。", {
      position: "bottom-left",
    });
    return;
  };
  return (
    <section className="mt-32 mx-auto w-fit">
      <div className="bg-white p-8 rounded-xl shadow-lg">
        <h1 className="text-3xl">
          <span>パスワード再設定</span>
        </h1>
        <p className="text-lg mb-2">
          パスワードを再設定します。
          <br />
          再設定のためのリンクが記載されたメールをお送りします。
        </p>
        <CheckEmail
          updateEmail={updateEmail}
          message="アカウントのメールアドレスを登録してください。"
          buttonMessage="送信する"
        />
        {status === "success" && (
          <p>
            送信されたメールをご確認ください。
          </p>
        )}
      </div>
      {waiting && (
        <div className="fixed inset-0 flex justify-center items-center bg-white bg-opacity-75 z-10">
          <ClipLoader color="#4A90E2" size={50} />
        </div>
      )}
    </section>
  );
}
